import React from "react";
import { useTranslation } from "react-i18next";

import { Text } from "@/components/Text";
import { IUser } from "@/data/users";
import { Checkbox, Flex } from "@/eworkitComponents";
import { IFilterComponentProps } from "@/infrastructure/Filter";

const simplifyUser = ({ id, firstName, lastName }: Partial<IUser>): Partial<IUser> => ({ id, firstName, lastName });

interface Props extends IFilterComponentProps {
  currentUser: Partial<IUser>;
  currentAssignees?: Array<Partial<IUser>>;
}

const UserTasksFilterComponent: React.FC<Props> = ({ value, currentAssignees = [], currentUser, onChange }) => {
  const { t } = useTranslation("session");

  const handleOptionChange = (checked: boolean) => {
    if (checked) {
      const assignees = [...currentAssignees, simplifyUser(currentUser!)];
      onChange({ assignees });
    } else {
      onChange({ assignees: currentAssignees.filter(a => a.id !== currentUser?.id) });
    }
  };

  const isChecked = value || Boolean(currentAssignees.find(a => a.id === currentUser?.id));

  return (
    <Flex direction="column" width={6}>
      <Checkbox checked={isChecked} onChange={handleOptionChange}>
        <Text size="md" color="black">
          {t("TASKS.FILTERS.MY_TASKS_LABEL")}
        </Text>
      </Checkbox>
    </Flex>
  );
};

export const UserTasksFilter = React.memo(UserTasksFilterComponent);
